/**
 * Backend API origin (scheme + host + port). Set via VUE_APP_API_URL in `.env`.
 * No trailing slash. Use empty string to call the API on the same origin as the SPA.
 */
export const apiBaseURL = process.env.VUE_APP_API_URL || "";

if (process.env.NODE_ENV === "development" && !process.env.VUE_APP_API_URL) {
  console.warn(
    "[CRM] VUE_APP_API_URL is not set. Create a `.env` file with VUE_APP_API_URL=<your-api-origin>"
  );
}
